/** The handful of shapes the CLI actually destructures. */
export const is = {
  string: (value: unknown) => typeof value === "string",
  // Absent passes: a field a deployment older than this binary does not send.
  optionalString: (value: unknown) =>
    value === undefined || typeof value === "string",
  number: (value: unknown) => typeof value === "number",
  array: (value: unknown) => Array.isArray(value),
  object: (value: unknown) =>
    Boolean(value) && typeof value === "object" && !Array.isArray(value),
};
